import React from 'react';
import { Checkbox } from 'semantic-ui-react';

import { TableLayout } from 'components/FilterableTable/FilterableTable';
import { Place } from 'scenes/Home/scenes/MerchantVenuesOnboarding/MerchantVenuesOnboarding.helpers';

const getIdsFromPlaces = (places: Place[]) =>
  places.map(({ externalId }) => externalId);

const getSelectedPlaces = (
  allPlaces: Place[],
  selectedPlaces: string[],
): Place[] =>
  selectedPlaces.map((selectedId) =>
    allPlaces.find((p) => p.externalId === selectedId),
  ) as Place[];

const getOnboardVenuesTableLayout = (
  classes: any,
  selectedPlaces: string[],
  handleSelectPlace: any,
  handleSelectAllPlaces: any,
  allSelected: boolean,
): TableLayout[] => [
  {
    SourceComponent: ({ row }: { row: Place }) => (
      <Checkbox
        checked={selectedPlaces.includes(row.externalId)}
        value={row.externalId}
        onChange={handleSelectPlace}
      />
    ),
    LabelComponent: () => (
      <div className={classes.selectAllHeader}>
        <Checkbox checked={allSelected} onChange={handleSelectAllPlaces} />
      </div>
    ),
  },
  {
    source: ['name'],
    label: 'Name',
  },
  {
    source: ['address', 'street'],
    label: 'Address',
  },
  {
    source: ['address', 'city'],
    label: 'City',
  },
  {
    source: ['address', 'state'],
    label: 'State',
  },
  {
    source: ['address', 'postal'],
    label: 'Postal Code',
  },
];

export {
  Place,
  getOnboardVenuesTableLayout,
  getSelectedPlaces,
  getIdsFromPlaces,
};
